import React from "react";
import { connect } from "react-redux";
import { fetchEmployees, createPayroll } from "@redux/actions";
import withStyles from "@material-ui/core/styles/withStyles";
import * as Yup from "yup";
import {
  Checkbox,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  Paper,
  TextField,
  Grid,
  Button,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { isMobile, matchIdInArray } from "@utils/utils";
import GenerateMonthBankSlip from "./PrintAble/GenerateMonthBankSlip";
import GeneratePayslip from "./PrintAble/GeneratePayslip";
import { isEmpty } from "lodash";
import { toastStyle } from "@styles/styledComponents";

const styles = (theme) => ({
  paper: {
    margin: "auto",
    width: 600,
    padding: theme.spacing.unit,
  },
  form: {
    padding: theme.spacing.unit * 2,
  },
  textField: {
    marginTop: theme.spacing.unit * 2,
    width: "100%",
  },
  halfTextField: {
    width: "50%",
  },
  checkbox: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit,
  },
  submitButton: {
    margin: theme.spacing.unit,
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    width: "100%",
  },
});

class CreatePayroll extends React.Component {
  userSchema = Yup.object().shape({
    email: Yup.string()
      .email("The e-mail must be a valid email address.")
      .required("The e-mail field is required."),
  });

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: true,
      employeeId: "",
      late_arrivals: 0,
      exemptions: 2,
      bonus_note: "",
      deduction_note: "",
      commission_note: "",
      advance_deduction: 0,
      checkbox: false,
      contract: "",
      salary_date: new Date().toISOString().slice(0, 7),
      isSubmit: false,
    };
  }

  componentDidMount = async () => {
    if (isEmpty(this.props.employees)) await this.props.fetchEmployees();
    const employees = this.props.employees;

    this.setState({
      isLoading: false,
      data: employees,
      contract: employees[0].contract,
      employeeId: employees[0]._id,
    });
  };

  handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    if (name === "employeeId") {
      const employee = matchIdInArray(this.state.data, value);

      this.setState({
        contract: employee.contract,
        late_arrivals: 0,
      });
    }
    this.setState({
      [name]: value,
    });
  };

  hasError = (field) => {
    return this.state.validation[field] != null;
  };

  handleSubmit = async (event, type) => {
    this.setState({ isSubmit: true });
    event.preventDefault();
    if (type === "all") {
      const { data, salary_date } = this.state;
      const employees = data.filter(
        (employee) => employee.contract !== "Hourly"
      );
      for (let i = 0; i < employees.length; i++) {
        const emp = employees[i];
        const payload = {
          employee_id: emp._id,
          employee_name: `${emp.first_name} ${emp.last_name}`,
          job_title: emp.job_title,
          bonus_note: "",
          deduction_note: "",
          commission_note: "",
          // exemptions: !exemptions ? "2" : exemptions,
          salary: emp.salary,
          medical_allowance: emp.medical_allowance,
          // late_arrivals: late_arrivals,
          salary_date: salary_date,
          advance_deduction: "0",
          incentive: "0",
          commission: "0",
          contract: emp.contract,
          joining_date: emp.joining_date,
          yearly_quota: emp.yearly_quota + emp.additional_yearly_quota,
          // no_of_hours: no_of_hours,
        };

        try {
          const response = await this.props.createPayroll(payload);
          if (response.data.success) {
            toast.success("Payroll created successfully", {
              ...toastStyle,
              type: "success",
            });
          } else {
            toast.error(response.data.message, {
              ...toastStyle,
              type: "error",
            });
          }
        } catch (error) {
          console.error("Error creating payroll:", error);
          toast.error("An error occurred while creating payroll", {
            ...toastStyle,
            type: "error",
          });
        }
      }
    } else {
      const {
        data,
        employeeId,
        salary_date,
        bonus_note,
        deduction_note,
        commission_note,
        advance_deduction,
        contract,
        created_at,
        no_of_hours,
        incentive,
        commission,
      } = this.state;
      const employee = matchIdInArray(data, employeeId);

      const {
        salary,
        first_name,
        last_name,
        job_title,
        joining_date,
        medical_allowance,
        yearly_quota,
        perHourSalary,
        additional_yearly_quota
      } = employee;

      const payload = {
        employee_id: employeeId,
        employee_name: `${first_name} ${last_name}`,
        job_title: job_title,
        bonus_note: bonus_note,
        deduction_note: deduction_note,
        commission_note: commission_note,
        salary: salary,
        medical_allowance,
        salary_date: salary_date,
        advance_deduction: !advance_deduction ? "0" : advance_deduction,
        incentive: !incentive ? "0" : incentive,
        commission: !commission ? "0" : commission,
        contract,
        created_at: created_at,
        no_of_hours: no_of_hours,
        perHourSalary: perHourSalary,
        joining_date,
        yearly_quota: yearly_quota + additional_yearly_quota,
      };

      try {
        const response = await this.props.createPayroll(payload);
        if (response.data.success) {
          toast.success("Payroll created successfully", {
            ...toastStyle,
            type: "success",
          });

          // Clear the form fields or perform any other necessary actions
          this.setState({
            bonus_note: "",
            deduction_note: "",
            late_arrivals: "",
            exemptions: "",
            employeeId: data[0]._id,
          });
        } else {
          toast.error(response.data.message, {
            ...toastStyle,
            type: "error",
          });
        }
      } catch (error) {
        console.error("Error creating payroll:", error);
        toast.error("An error occurred while creating payroll", {
          ...toastStyle,
          type: "error",
        });
      }
    }
    this.setState({ isSubmit: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        {this.state.isLoading ? (
          <div className="LoaderWrapper">
            <CircularProgress />
          </div>
        ) : (
          <div className="d-flex flex-wrap justify-content-center gap-4 pe-2">
            <Paper className={classes.paper}>
              <form
                className={classes.form}
                autoComplete="off"
                onSubmit={this.handleSubmit}
              >
                <TextField
                  label="Employee Name"
                  name="employeeId"
                  required
                  fullWidth
                  value={this.state.employeeId}
                  onChange={this.handleChange}
                  select
                >
                  {this.state.data.map(function (employee, i) {
                    return (
                      <MenuItem value={employee._id} key={i}>
                        {employee.first_name} {employee.last_name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <TextField
                  id="salary_date"
                  name="salary_date"
                  label="Choose Month"
                  required
                  type="month"
                  value={this.state.salary_date}
                  onChange={this.handleChange}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {this.state.contract === "Hourly" && (
                  <TextField
                    id="no_of_hours"
                    name="no_of_hours"
                    label="No of Hours"
                    fullWidth
                    required
                    type="float"
                    placeholder="0"
                    className={
                      isMobile() ? classes.TextField : classes.halfTextField
                    }
                    onChange={this.handleChange}
                    margin="normal"
                  />
                )}
                <FormControlLabel
                  value="end"
                  control={
                    <Checkbox
                      color="primary"
                      onChange={() =>
                        this.setState({ checkbox: !this.state.checkbox })
                      }
                    />
                  }
                  label="Advance"
                  className={classes.checkbox}
                  labelPlacement="end"
                />
                <br />
                {this.state.checkbox && (
                  <>
                    <TextField
                      id="advance_deduction"
                      name="advance_deduction"
                      label="Advance Deductions"
                      type="number"
                      defaultValue={0}
                      className={
                        isMobile() ? classes.TextField : classes.halfTextField
                      }
                      onChange={this.handleChange}
                      margin="normal"
                    />
                    <TextField
                      id="incentive"
                      name="incentive"
                      label="Incentive"
                      type="number"
                      defaultValue={0}
                      className={
                        isMobile() ? classes.TextField : classes.halfTextField
                      }
                      onChange={this.handleChange}
                      margin="normal"
                    />
                    <TextField
                      id="commission"
                      name="commission"
                      label="Commission"
                      type="number"
                      defaultValue={0}
                      className={
                        isMobile() ? classes.TextField : classes.halfTextField
                      }
                      onChange={this.handleChange}
                      margin="normal"
                    />
                    <TextField
                      id="commission_note"
                      name="commission_note"
                      label="Commission Note"
                      multiline
                      value={this.state.commission_note}
                      type="text"
                      InputProps={{ inputProps: { min: 0 } }}
                      className={classes.textField}
                      onChange={this.handleChange}
                      margin="normal"
                    />
                    <TextField
                      id="bonus_note"
                      name="bonus_note"
                      label="Bonus Note"
                      multiline
                      value={this.state.bonus_note}
                      type="text"
                      InputProps={{ inputProps: { min: 0 } }}
                      className={classes.textField}
                      onChange={this.handleChange}
                      margin="normal"
                    />
                    <TextField
                      id="deduction_note"
                      name="deduction_note"
                      label="Deduction Note"
                      multiline
                      value={this.state.deduction_note}
                      type="text"
                      InputProps={{ inputProps: { min: 0 } }}
                      className={classes.textField}
                      onChange={this.handleChange}
                      margin="normal"
                    />
                  </>
                )}
                <br />
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="flex-end"
                >
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                      disabled={this.state.isSubmit}
                    >
                      Create
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Paper>
            <Paper className={classes.paper}>
              <form
                className={classes.form}
                autoComplete="off"
                onSubmit={(e) => this.handleSubmit(e, "all")}
              >
                <p>Generate Payroll of all employees</p>
                <TextField
                  id="salary_date"
                  name="salary_date"
                  label="Choose Month"
                  required
                  type="month"
                  value={this.state.salary_date}
                  onChange={this.handleChange}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <br />
                <br />
                <br />
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="flex-end"
                >
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                      disabled={this.state.isSubmit}
                    >
                      Generate Payrolls
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Paper>
            <Paper className={classes.paper}>
              <GenerateMonthBankSlip />
            </Paper>
            <Paper className={classes.paper}>
              <GeneratePayslip employees={this.state.data} />
            </Paper>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    employees: state.employees?.payload,
  };
};

export default connect(mapStateToProps, {
  fetchEmployees,
  createPayroll,
})(withStyles(styles)(CreatePayroll));
